import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackagePlans } from '../store/slices/packagePlansSlice';

export const usePackagePlans = (branchId, placeId) => {
    const dispatch = useDispatch();
    const { packagePlans, loading, error } = useSelector((state) => state.packagePlans);

    const refetchPackagePlans = useCallback(() => {
        if (branchId) {
            dispatch(fetchPackagePlans({ branchId, placeId }));
        }
    }, [dispatch, branchId, placeId]);

    useEffect(() => {
        refetchPackagePlans();
    }, [refetchPackagePlans]);

    return {
        packagePlans,
        loading,
        error,
        refetchPackagePlans
    };
};
